import logo from './logo.png';
import styles from './styles.module.css';
import React from 'react';
import { Container, Grid, Hidden } from '@mui/material';
import { useTranslation } from 'react-i18next';
export default function Footer() {
  const { t: tCommon } = useTranslation('common');

  return (
    <Grid className={styles.footerMainDiv}>
      <Container>
        <Grid container className={styles.upperDiv}>
          <Grid item className={styles.companyDetailDiv}>
            <Grid>
              <img
                alt={tCommon('Sanoft POS logo – best billing software and best billing app for small businesses')}
                src={logo}
                width="95"
                height="100"
              />
            </Grid>

            <Hidden xsDown>
              <Grid style={{ marginLeft: 20 }}>
                <div className={styles.footerItem}>
                  <h4>{tCommon('Sanoft Technologies Pvt Ltd.')}</h4>
                </div>
              </Grid>
            </Hidden>
          </Grid>
          <Grid item className={styles.companyDetailDiv}>
            <Grid>
              <div className={styles.footerItem}>
                <h5 style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.sanoft.com/', '_blank')}>
                  {tCommon('About us')}
                </h5>
              </div>
              <div className={styles.footerItem}>
                <h5 style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.sanoft.com/', '_blank')}>
                  {tCommon('Contact Us')}
                </h5>
              </div>
              <div className={styles.footerItem}>
                <h5
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    window.open('https://drive.google.com/file/d/1ZCa7_afvQS6iFFDTyHIvB4h8Gqq9AzBN/view', '_blank')
                  }
                >
                  {tCommon('Privacy policy')}
                </h5>
              </div>
              <div className={styles.footerItem}>
                <h5
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    window.open('https://drive.google.com/file/d/1ZCa7_afvQS6iFFDTyHIvB4h8Gqq9AzBN/view', '_blank')
                  }
                >
                  {tCommon('Return policy')}
                </h5>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid container className={styles.lowerDiv}>
          <h6 className={styles.copyRight} style={{ color: '#FFF', textAlign: 'center' }}>
            {tCommon('Copyright © 2021')}{' '}
            <span
              style={{ color: '#272C86', cursor: 'pointer' }}
              onClick={() => window.open('https://www.sanoft.com/', '_blank')}
            >
              {tCommon('Sanoft Technologies Pvt Ltd.').split(' ')[0]}{' '}
            </span>
            | {tCommon('All Rights Reserved.')} | {tCommon('Powered By')}{' '}
            <span
              style={{ color: '#272C86', cursor: 'pointer' }}
              onClick={() => window.open('https://www.sanoft.com/', '_blank')}
            >
              {tCommon('Sanoft Technologies Pvt Ltd.')}
            </span>
          </h6>
        </Grid>
      </Container>
    </Grid>
  );
}
